import React, { useState } from "react";

export default function LearningPaths() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [courseList, setCourseList] = useState([]);
  const [savedPaths, setSavedPaths] = useState([]);

  const [allCourses] = useState([
    "Safety Training",
    "Customer Service",
    "Cyber Security",
    "Leadership Basics",
    "Conflict Resolution",
  ]);

  const addCourse = () => {
    if (selectedCourse && !courseList.includes(selectedCourse)) {
      setCourseList([...courseList, selectedCourse]);
      setSelectedCourse("");
    }
  };

  const savePath = () => {
    if (!title || courseList.length === 0) {
      alert("Title and at least one course required.");
      return;
    }

    const newPath = { title, description, courses: courseList };
    setSavedPaths([...savedPaths, newPath]);
    setTitle("");
    setDescription("");
    setCourseList([]);
  };

  const deletePath = (index) => {
    const updated = [...savedPaths];
    updated.splice(index, 1);
    setSavedPaths(updated);
  };

  return (
    <div className="max-w-5xl mx-auto p-6 space-y-10">
      <h2 className="text-2xl font-bold mb-4">Learning Path Builder</h2>

      <div className="bg-white p-6 rounded shadow space-y-6 border">
        <div>
          <label className="block mb-1 font-medium">Path Title</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full border rounded px-3 py-2"
            placeholder="e.g., New Hire Onboarding"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full border rounded px-3 py-2"
            rows={3}
            placeholder="Optional"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Add Courses (in order)</label>
          <div className="flex items-center gap-4">
            <select
              value={selectedCourse}
              onChange={(e) => setSelectedCourse(e.target.value)}
              className="border rounded px-3 py-2 w-full max-w-sm"
            >
              <option value="">Select a course</option>
              {allCourses.map((course) => (
                <option key={course} value={course}>
                  {course}
                </option>
              ))}
            </select>
            <button
              onClick={addCourse}
              className="bg-black text-white px-4 py-2 rounded hover:bg-gray-800"
            >
              Add
            </button>
          </div>
        </div>

        {courseList.length > 0 && (
          <ul className="list-decimal pl-6 space-y-1 text-sm text-gray-800">
            {courseList.map((course, i) => (
              <li key={i}>{course}</li>
            ))}
          </ul>
        )}

        <button
          onClick={savePath}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700"
        >
          Save Path
        </button>
      </div>

      {/* Saved Paths */}
      {savedPaths.length > 0 && (
        <div className="space-y-6">
          <h3 className="text-xl font-semibold">Saved Learning Paths</h3>
          {savedPaths.map((path, idx) => (
            <div key={idx} className="bg-white border rounded p-4 shadow">
              <h4 className="font-semibold text-lg">{path.title}</h4>
              {path.description && (
                <p className="text-sm text-gray-600 mb-2">{path.description}</p>
              )}
              <ul className="list-decimal pl-5 text-sm mb-2">
                {path.courses.map((course, i) => (
                  <li key={i}>{course}</li>
                ))}
              </ul>
              <button
                onClick={() => deletePath(idx)}
                className="text-red-600 text-sm hover:underline"
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
